import { Box, Grid, Image, Stack, Text } from '@mantine/core';
import { format } from 'date-fns';
import { MessageFormValue } from '#/components/ui/messages/model';
import { imageUploadField } from '../MessageImageUpload';

export const PushNotiPreview = ({ value }: { value: MessageFormValue }) => {
  const formattedTime = value.scheduleAt
    ? format(new Date(value.scheduleAt), 'yyyy-MM-dd HH:mm')
    : '2099-99-99 23:59';

  const thumbUrlSrc = imageUploadField.toPreviewUrl(value.thumbUrl);

  return (
    <Box className="border border-gray-200 rounded-lg bg-white p-4 w-100">
      <Grid align="center" gap="md">
        <Grid.Col span={3}>
          {thumbUrlSrc ? (
            <Image
              src={thumbUrlSrc}
              alt={value.title}
              radius="sm"
              fit="cover"
              className="aspect-square w-full"
            />
          ) : (
            <Box className="aspect-square w-full rounded-sm bg-gray-200" />
          )}
        </Grid.Col>
        <Grid.Col span={9}>
          <Stack gap={4}>
            <Text fw={600} size="md" c="dark" className="truncate">
              {value.title || '標題標題標題標題標題標題標題標題標題標題標題'}
            </Text>
            <Text size="sm" c="gray.6" className="text-ellipsis">
              {value.summary ||
                '內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文'}
            </Text>
            <Text size="xs" c="gray.5">
              {formattedTime}
            </Text>
          </Stack>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default PushNotiPreview;
